// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/organization.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse, SortOrder } from "./pagination_pb.js";
import { UserStatus } from "./user_pb.js";

/**
 * @generated from enum gitpod.v1.OrganizationTier
 */
export enum OrganizationTier {
  /**
   * @generated from enum value: ORGANIZATION_TIER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORGANIZATION_TIER_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: ORGANIZATION_TIER_ENTERPRISE = 2;
   */
  ENTERPRISE = 2,

  /**
   * @generated from enum value: ORGANIZATION_TIER_CORE = 3;
   */
  CORE = 3,

  /**
   * @generated from enum value: ORGANIZATION_TIER_FREE_ONA = 4;
   */
  FREE_ONA = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(OrganizationTier)
proto3.util.setEnumType(OrganizationTier, "gitpod.v1.OrganizationTier", [
  { no: 0, name: "ORGANIZATION_TIER_UNSPECIFIED" },
  { no: 1, name: "ORGANIZATION_TIER_FREE" },
  { no: 2, name: "ORGANIZATION_TIER_ENTERPRISE" },
  { no: 3, name: "ORGANIZATION_TIER_CORE" },
  { no: 4, name: "ORGANIZATION_TIER_FREE_ONA" },
]);

/**
 * @generated from enum gitpod.v1.OrganizationRole
 */
export enum OrganizationRole {
  /**
   * @generated from enum value: ORGANIZATION_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: ORGANIZATION_ROLE_MEMBER = 2;
   */
  MEMBER = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(OrganizationRole)
proto3.util.setEnumType(OrganizationRole, "gitpod.v1.OrganizationRole", [
  { no: 0, name: "ORGANIZATION_ROLE_UNSPECIFIED" },
  { no: 1, name: "ORGANIZATION_ROLE_ADMIN" },
  { no: 2, name: "ORGANIZATION_ROLE_MEMBER" },
]);

/**
 * @generated from enum gitpod.v1.SSOConfigurationState
 */
export enum SSOConfigurationState {
  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_UNSPECIFIED = 0;
   */
  SSO_CONFIGURATION_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_INACTIVE = 1;
   */
  SSO_CONFIGURATION_STATE_INACTIVE = 1,

  /**
   * @generated from enum value: SSO_CONFIGURATION_STATE_ACTIVE = 2;
   */
  SSO_CONFIGURATION_STATE_ACTIVE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SSOConfigurationState)
proto3.util.setEnumType(SSOConfigurationState, "gitpod.v1.SSOConfigurationState", [
  { no: 0, name: "SSO_CONFIGURATION_STATE_UNSPECIFIED" },
  { no: 1, name: "SSO_CONFIGURATION_STATE_INACTIVE" },
  { no: 2, name: "SSO_CONFIGURATION_STATE_ACTIVE" },
]);

/**
 * @generated from enum gitpod.v1.DomainVerificationState
 */
export enum DomainVerificationState {
  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DOMAIN_VERIFICATION_STATE_VERIFIED = 2;
   */
  VERIFIED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(DomainVerificationState)
proto3.util.setEnumType(DomainVerificationState, "gitpod.v1.DomainVerificationState", [
  { no: 0, name: "DOMAIN_VERIFICATION_STATE_UNSPECIFIED" },
  { no: 1, name: "DOMAIN_VERIFICATION_STATE_PENDING" },
  { no: 2, name: "DOMAIN_VERIFICATION_STATE_VERIFIED" },
]);

/**
 * CustomDomainProvider represents the cloud provider for custom domain configuration
 *
 * @generated from enum gitpod.v1.CustomDomainProvider
 */
export enum CustomDomainProvider {
  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_AWS = 1;
   */
  AWS = 1,

  /**
   * @generated from enum value: CUSTOM_DOMAIN_PROVIDER_GCP = 2;
   */
  GCP = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CustomDomainProvider)
proto3.util.setEnumType(CustomDomainProvider, "gitpod.v1.CustomDomainProvider", [
  { no: 0, name: "CUSTOM_DOMAIN_PROVIDER_UNSPECIFIED" },
  { no: 1, name: "CUSTOM_DOMAIN_PROVIDER_AWS" },
  { no: 2, name: "CUSTOM_DOMAIN_PROVIDER_GCP" },
]);

/**
 * @generated from message gitpod.v1.UpdateOrganizationRequest
 */
export class UpdateOrganizationRequest extends Message<UpdateOrganizationRequest> {
  /**
   * organization_id is the ID of the organization to update the settings for.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is the new name of the organization
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * invite_domains is the domain allowlist of the organization
   *
   * @generated from field: optional gitpod.v1.InviteDomains invite_domains = 3;
   */
  inviteDomains?: InviteDomains;

  constructor(data?: PartialMessage<UpdateOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "invite_domains", kind: "message", T: InviteDomains, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationRequest {
    return new UpdateOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationRequest {
    return new UpdateOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationRequest {
    return new UpdateOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationRequest | PlainMessage<UpdateOrganizationRequest> | undefined, b: UpdateOrganizationRequest | PlainMessage<UpdateOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationResponse
 */
export class UpdateOrganizationResponse extends Message<UpdateOrganizationResponse> {
  /**
   * organization is the updated organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;

  constructor(data?: PartialMessage<UpdateOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization", kind: "message", T: Organization },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationResponse {
    return new UpdateOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationResponse {
    return new UpdateOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationResponse {
    return new UpdateOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationResponse | PlainMessage<UpdateOrganizationResponse> | undefined, b: UpdateOrganizationResponse | PlainMessage<UpdateOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateOrganizationRequest
 */
export class CreateOrganizationRequest extends Message<CreateOrganizationRequest> {
  /**
   * name is the organization name
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * join_organization decides whether the Identity issuing this request joins the org on creation
   *
   * @generated from field: bool join_organization = 2;
   */
  joinOrganization = false;

  /**
   * Should other Accounts with the same domain be automatically invited to the organization?
   *
   * @generated from field: bool invite_accounts_with_matching_domain = 3;
   */
  inviteAccountsWithMatchingDomain = false;

  constructor(data?: PartialMessage<CreateOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "join_organization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "invite_accounts_with_matching_domain", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationRequest {
    return new CreateOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationRequest {
    return new CreateOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationRequest {
    return new CreateOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationRequest | PlainMessage<CreateOrganizationRequest> | undefined, b: CreateOrganizationRequest | PlainMessage<CreateOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateOrganizationResponse
 */
export class CreateOrganizationResponse extends Message<CreateOrganizationResponse> {
  /**
   * organization is the created organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * member is the member that joined the org on creation. Only set if specified "join_organization" is "true" in the request.
   *
   * @generated from field: gitpod.v1.OrganizationMember member = 2;
   */
  member?: OrganizationMember;

  constructor(data?: PartialMessage<CreateOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization", kind: "message", T: Organization },
    { no: 2, name: "member", kind: "message", T: OrganizationMember },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationResponse {
    return new CreateOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationResponse {
    return new CreateOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationResponse {
    return new CreateOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationResponse | PlainMessage<CreateOrganizationResponse> | undefined, b: CreateOrganizationResponse | PlainMessage<CreateOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.JoinOrganizationRequest
 */
export class JoinOrganizationRequest extends Message<JoinOrganizationRequest> {
  /**
   * @generated from oneof gitpod.v1.JoinOrganizationRequest.join_id
   */
  joinId: {
    /**
     * organization_id is the unique identifier of the Organization to join.
     *
     * @generated from field: string organization_id = 1;
     */
    value: string;
    case: "organizationId";
  } | {
    /**
     * invite_id is the unique identifier of the invite to join the organization.
     *
     * @generated from field: string invite_id = 2;
     */
    value: string;
    case: "inviteId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<JoinOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.JoinOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "join_id" },
    { no: 2, name: "invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "join_id" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinOrganizationRequest {
    return new JoinOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinOrganizationRequest {
    return new JoinOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinOrganizationRequest {
    return new JoinOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: JoinOrganizationRequest | PlainMessage<JoinOrganizationRequest> | undefined, b: JoinOrganizationRequest | PlainMessage<JoinOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(JoinOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.JoinOrganizationResponse
 */
export class JoinOrganizationResponse extends Message<JoinOrganizationResponse> {
  /**
   * member is the member that was created by joining the organization.
   *
   * @generated from field: gitpod.v1.OrganizationMember member = 1;
   */
  member?: OrganizationMember;

  constructor(data?: PartialMessage<JoinOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.JoinOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "member", kind: "message", T: OrganizationMember },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinOrganizationResponse {
    return new JoinOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinOrganizationResponse {
    return new JoinOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinOrganizationResponse {
    return new JoinOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: JoinOrganizationResponse | PlainMessage<JoinOrganizationResponse> | undefined, b: JoinOrganizationResponse | PlainMessage<JoinOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(JoinOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.LeaveOrganizationRequest
 */
export class LeaveOrganizationRequest extends Message<LeaveOrganizationRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<LeaveOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.LeaveOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LeaveOrganizationRequest {
    return new LeaveOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LeaveOrganizationRequest {
    return new LeaveOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LeaveOrganizationRequest {
    return new LeaveOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LeaveOrganizationRequest | PlainMessage<LeaveOrganizationRequest> | undefined, b: LeaveOrganizationRequest | PlainMessage<LeaveOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(LeaveOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.LeaveOrganizationResponse
 */
export class LeaveOrganizationResponse extends Message<LeaveOrganizationResponse> {
  constructor(data?: PartialMessage<LeaveOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.LeaveOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LeaveOrganizationResponse {
    return new LeaveOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LeaveOrganizationResponse {
    return new LeaveOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LeaveOrganizationResponse {
    return new LeaveOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LeaveOrganizationResponse | PlainMessage<LeaveOrganizationResponse> | undefined, b: LeaveOrganizationResponse | PlainMessage<LeaveOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(LeaveOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationRequest
 */
export class GetOrganizationRequest extends Message<GetOrganizationRequest> {
  /**
   * organization_id is the unique identifier of the Organization to retreive.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationRequest {
    return new GetOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationRequest {
    return new GetOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationRequest {
    return new GetOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationRequest | PlainMessage<GetOrganizationRequest> | undefined, b: GetOrganizationRequest | PlainMessage<GetOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationResponse
 */
export class GetOrganizationResponse extends Message<GetOrganizationResponse> {
  /**
   * organization is the requested organization
   *
   * @generated from field: gitpod.v1.Organization organization = 1;
   */
  organization?: Organization;

  constructor(data?: PartialMessage<GetOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization", kind: "message", T: Organization },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationResponse {
    return new GetOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationResponse {
    return new GetOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationResponse {
    return new GetOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationResponse | PlainMessage<GetOrganizationResponse> | undefined, b: GetOrganizationResponse | PlainMessage<GetOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteOrganizationRequest
 */
export class DeleteOrganizationRequest extends Message<DeleteOrganizationRequest> {
  /**
   * organization_id is the ID of the organization to delete
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<DeleteOrganizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteOrganizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteOrganizationRequest {
    return new DeleteOrganizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteOrganizationRequest {
    return new DeleteOrganizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteOrganizationRequest {
    return new DeleteOrganizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteOrganizationRequest | PlainMessage<DeleteOrganizationRequest> | undefined, b: DeleteOrganizationRequest | PlainMessage<DeleteOrganizationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteOrganizationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteOrganizationResponse
 */
export class DeleteOrganizationResponse extends Message<DeleteOrganizationResponse> {
  constructor(data?: PartialMessage<DeleteOrganizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteOrganizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteOrganizationResponse {
    return new DeleteOrganizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteOrganizationResponse {
    return new DeleteOrganizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteOrganizationResponse {
    return new DeleteOrganizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteOrganizationResponse | PlainMessage<DeleteOrganizationResponse> | undefined, b: DeleteOrganizationResponse | PlainMessage<DeleteOrganizationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteOrganizationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMembersRequest
 */
export class ListMembersRequest extends Message<ListMembersRequest> {
  /**
   * pagination contains the pagination options for listing members
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * organization_id is the ID of the organization to list members for
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * @generated from field: gitpod.v1.ListMembersRequest.Filter filter = 3;
   */
  filter?: ListMembersRequest_Filter;

  /**
   * sort specifies the order of results. When unspecified, the authenticated user is
   * returned first, followed by other members sorted by name ascending. When an explicit
   * sort is specified, results are sorted purely by the requested field without any
   * special handling for the authenticated user.
   *
   * @generated from field: gitpod.v1.ListMembersRequest.Sort sort = 4;
   */
  sort?: ListMembersRequest_Sort;

  constructor(data?: PartialMessage<ListMembersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListMembersRequest_Filter },
    { no: 4, name: "sort", kind: "message", T: ListMembersRequest_Sort },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembersRequest {
    return new ListMembersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembersRequest {
    return new ListMembersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembersRequest {
    return new ListMembersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembersRequest | PlainMessage<ListMembersRequest> | undefined, b: ListMembersRequest | PlainMessage<ListMembersRequest> | undefined): boolean {
    return proto3.util.equals(ListMembersRequest, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.ListMembersRequest.SortField
 */
export enum ListMembersRequest_SortField {
  /**
   * @generated from enum value: SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort by member's display name
   *
   * @generated from enum value: SORT_FIELD_NAME = 1;
   */
  NAME = 1,

  /**
   * Sort by the date the member joined the organization
   *
   * @generated from enum value: SORT_FIELD_DATE_JOINED = 2;
   */
  DATE_JOINED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ListMembersRequest_SortField)
proto3.util.setEnumType(ListMembersRequest_SortField, "gitpod.v1.ListMembersRequest.SortField", [
  { no: 0, name: "SORT_FIELD_UNSPECIFIED" },
  { no: 1, name: "SORT_FIELD_NAME" },
  { no: 2, name: "SORT_FIELD_DATE_JOINED" },
]);

/**
 * @generated from message gitpod.v1.ListMembersRequest.Filter
 */
export class ListMembersRequest_Filter extends Message<ListMembersRequest_Filter> {
  /**
   * search performs case-insensitive search across member name and email
   *
   * @generated from field: string search = 1;
   */
  search = "";

  /**
   * status filters members by their user status
   *
   * @generated from field: repeated gitpod.v1.UserStatus statuses = 2;
   */
  statuses: UserStatus[] = [];

  /**
   * roles filters members by their organization role
   *
   * @generated from field: repeated gitpod.v1.OrganizationRole roles = 3;
   */
  roles: OrganizationRole[] = [];

  constructor(data?: PartialMessage<ListMembersRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembersRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "statuses", kind: "enum", T: proto3.getEnumType(UserStatus), repeated: true },
    { no: 3, name: "roles", kind: "enum", T: proto3.getEnumType(OrganizationRole), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembersRequest_Filter {
    return new ListMembersRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembersRequest_Filter {
    return new ListMembersRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembersRequest_Filter {
    return new ListMembersRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembersRequest_Filter | PlainMessage<ListMembersRequest_Filter> | undefined, b: ListMembersRequest_Filter | PlainMessage<ListMembersRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListMembersRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMembersRequest.Sort
 */
export class ListMembersRequest_Sort extends Message<ListMembersRequest_Sort> {
  /**
   * @generated from field: gitpod.v1.ListMembersRequest.SortField field = 1;
   */
  field = ListMembersRequest_SortField.UNSPECIFIED;

  /**
   * @generated from field: gitpod.v1.SortOrder order = 2;
   */
  order = SortOrder.UNSPECIFIED;

  constructor(data?: PartialMessage<ListMembersRequest_Sort>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembersRequest.Sort";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(ListMembersRequest_SortField) },
    { no: 2, name: "order", kind: "enum", T: proto3.getEnumType(SortOrder) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembersRequest_Sort {
    return new ListMembersRequest_Sort().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembersRequest_Sort {
    return new ListMembersRequest_Sort().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembersRequest_Sort {
    return new ListMembersRequest_Sort().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembersRequest_Sort | PlainMessage<ListMembersRequest_Sort> | undefined, b: ListMembersRequest_Sort | PlainMessage<ListMembersRequest_Sort> | undefined): boolean {
    return proto3.util.equals(ListMembersRequest_Sort, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMembersResponse
 */
export class ListMembersResponse extends Message<ListMembersResponse> {
  /**
   * pagination contains the pagination options for listing members
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * members are the members of the organization
   *
   * @generated from field: repeated gitpod.v1.OrganizationMember members = 2;
   */
  members: OrganizationMember[] = [];

  constructor(data?: PartialMessage<ListMembersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "members", kind: "message", T: OrganizationMember, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembersResponse {
    return new ListMembersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembersResponse {
    return new ListMembersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembersResponse {
    return new ListMembersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembersResponse | PlainMessage<ListMembersResponse> | undefined, b: ListMembersResponse | PlainMessage<ListMembersResponse> | undefined): boolean {
    return proto3.util.equals(ListMembersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetRoleRequest
 */
export class SetRoleRequest extends Message<SetRoleRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gitpod.v1.OrganizationRole role = 3;
   */
  role = OrganizationRole.UNSPECIFIED;

  constructor(data?: PartialMessage<SetRoleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetRoleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(OrganizationRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetRoleRequest {
    return new SetRoleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetRoleRequest {
    return new SetRoleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetRoleRequest {
    return new SetRoleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetRoleRequest | PlainMessage<SetRoleRequest> | undefined, b: SetRoleRequest | PlainMessage<SetRoleRequest> | undefined): boolean {
    return proto3.util.equals(SetRoleRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetRoleResponse
 */
export class SetRoleResponse extends Message<SetRoleResponse> {
  constructor(data?: PartialMessage<SetRoleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetRoleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetRoleResponse {
    return new SetRoleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetRoleResponse {
    return new SetRoleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetRoleResponse {
    return new SetRoleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetRoleResponse | PlainMessage<SetRoleResponse> | undefined, b: SetRoleResponse | PlainMessage<SetRoleResponse> | undefined): boolean {
    return proto3.util.equals(SetRoleResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationInviteRequest
 */
export class GetOrganizationInviteRequest extends Message<GetOrganizationInviteRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetOrganizationInviteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationInviteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationInviteRequest {
    return new GetOrganizationInviteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationInviteRequest {
    return new GetOrganizationInviteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationInviteRequest {
    return new GetOrganizationInviteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationInviteRequest | PlainMessage<GetOrganizationInviteRequest> | undefined, b: GetOrganizationInviteRequest | PlainMessage<GetOrganizationInviteRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationInviteRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationInviteResponse
 */
export class GetOrganizationInviteResponse extends Message<GetOrganizationInviteResponse> {
  /**
   * @generated from field: gitpod.v1.OrganizationInvite invite = 1;
   */
  invite?: OrganizationInvite;

  constructor(data?: PartialMessage<GetOrganizationInviteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationInviteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invite", kind: "message", T: OrganizationInvite },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationInviteResponse {
    return new GetOrganizationInviteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationInviteResponse {
    return new GetOrganizationInviteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationInviteResponse {
    return new GetOrganizationInviteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationInviteResponse | PlainMessage<GetOrganizationInviteResponse> | undefined, b: GetOrganizationInviteResponse | PlainMessage<GetOrganizationInviteResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationInviteResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.OrganizationInvite
 */
export class OrganizationInvite extends Message<OrganizationInvite> {
  /**
   * invite_id is the unique identifier of the invite to join the organization.
   * Use JoinOrganization with this ID to join the organization.
   *
   * @generated from field: string invite_id = 1;
   */
  inviteId = "";

  constructor(data?: PartialMessage<OrganizationInvite>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.OrganizationInvite";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrganizationInvite {
    return new OrganizationInvite().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrganizationInvite {
    return new OrganizationInvite().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrganizationInvite {
    return new OrganizationInvite().fromJsonString(jsonString, options);
  }

  static equals(a: OrganizationInvite | PlainMessage<OrganizationInvite> | undefined, b: OrganizationInvite | PlainMessage<OrganizationInvite> | undefined): boolean {
    return proto3.util.equals(OrganizationInvite, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateOrganizationInviteRequest
 */
export class CreateOrganizationInviteRequest extends Message<CreateOrganizationInviteRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<CreateOrganizationInviteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationInviteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationInviteRequest {
    return new CreateOrganizationInviteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationInviteRequest {
    return new CreateOrganizationInviteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationInviteRequest {
    return new CreateOrganizationInviteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationInviteRequest | PlainMessage<CreateOrganizationInviteRequest> | undefined, b: CreateOrganizationInviteRequest | PlainMessage<CreateOrganizationInviteRequest> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationInviteRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateOrganizationInviteResponse
 */
export class CreateOrganizationInviteResponse extends Message<CreateOrganizationInviteResponse> {
  /**
   * @generated from field: gitpod.v1.OrganizationInvite invite = 1;
   */
  invite?: OrganizationInvite;

  constructor(data?: PartialMessage<CreateOrganizationInviteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateOrganizationInviteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invite", kind: "message", T: OrganizationInvite },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrganizationInviteResponse {
    return new CreateOrganizationInviteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrganizationInviteResponse {
    return new CreateOrganizationInviteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrganizationInviteResponse {
    return new CreateOrganizationInviteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrganizationInviteResponse | PlainMessage<CreateOrganizationInviteResponse> | undefined, b: CreateOrganizationInviteResponse | PlainMessage<CreateOrganizationInviteResponse> | undefined): boolean {
    return proto3.util.equals(CreateOrganizationInviteResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationInviteSummaryRequest
 */
export class GetOrganizationInviteSummaryRequest extends Message<GetOrganizationInviteSummaryRequest> {
  /**
   * @generated from field: string invite_id = 1;
   */
  inviteId = "";

  constructor(data?: PartialMessage<GetOrganizationInviteSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationInviteSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationInviteSummaryRequest {
    return new GetOrganizationInviteSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationInviteSummaryRequest {
    return new GetOrganizationInviteSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationInviteSummaryRequest {
    return new GetOrganizationInviteSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationInviteSummaryRequest | PlainMessage<GetOrganizationInviteSummaryRequest> | undefined, b: GetOrganizationInviteSummaryRequest | PlainMessage<GetOrganizationInviteSummaryRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationInviteSummaryRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationInviteSummaryResponse
 */
export class GetOrganizationInviteSummaryResponse extends Message<GetOrganizationInviteSummaryResponse> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string organization_name = 2;
   */
  organizationName = "";

  /**
   * @generated from field: int32 organization_member_count = 3;
   */
  organizationMemberCount = 0;

  constructor(data?: PartialMessage<GetOrganizationInviteSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationInviteSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "organization_member_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationInviteSummaryResponse {
    return new GetOrganizationInviteSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationInviteSummaryResponse {
    return new GetOrganizationInviteSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationInviteSummaryResponse {
    return new GetOrganizationInviteSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationInviteSummaryResponse | PlainMessage<GetOrganizationInviteSummaryResponse> | undefined, b: GetOrganizationInviteSummaryResponse | PlainMessage<GetOrganizationInviteSummaryResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationInviteSummaryResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Organization
 */
export class Organization extends Message<Organization> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: gitpod.v1.InviteDomains invite_domains = 5;
   */
  inviteDomains?: InviteDomains;

  /**
   * The tier of the organization - free, enterprise or core
   *
   * @generated from field: gitpod.v1.OrganizationTier tier = 6;
   */
  tier = OrganizationTier.UNSPECIFIED;

  constructor(data?: PartialMessage<Organization>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Organization";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "updated_at", kind: "message", T: Timestamp },
    { no: 5, name: "invite_domains", kind: "message", T: InviteDomains },
    { no: 6, name: "tier", kind: "enum", T: proto3.getEnumType(OrganizationTier) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Organization {
    return new Organization().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Organization {
    return new Organization().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Organization {
    return new Organization().fromJsonString(jsonString, options);
  }

  static equals(a: Organization | PlainMessage<Organization> | undefined, b: Organization | PlainMessage<Organization> | undefined): boolean {
    return proto3.util.equals(Organization, a, b);
  }
}

/**
 * @generated from message gitpod.v1.OrganizationMember
 */
export class OrganizationMember extends Message<OrganizationMember> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gitpod.v1.OrganizationRole role = 2;
   */
  role = OrganizationRole.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp member_since = 3;
   */
  memberSince?: Timestamp;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl = "";

  /**
   * @generated from field: string full_name = 5;
   */
  fullName = "";

  /**
   * @generated from field: string email = 6;
   */
  email = "";

  /**
   * @generated from field: gitpod.v1.UserStatus status = 7;
   */
  status = UserStatus.UNSPECIFIED;

  /**
   * login_provider is the login provider the user uses to sign in
   *
   * @generated from field: string login_provider = 8;
   */
  loginProvider = "";

  constructor(data?: PartialMessage<OrganizationMember>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.OrganizationMember";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(OrganizationRole) },
    { no: 3, name: "member_since", kind: "message", T: Timestamp },
    { no: 4, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(UserStatus) },
    { no: 8, name: "login_provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrganizationMember {
    return new OrganizationMember().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrganizationMember {
    return new OrganizationMember().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrganizationMember {
    return new OrganizationMember().fromJsonString(jsonString, options);
  }

  static equals(a: OrganizationMember | PlainMessage<OrganizationMember> | undefined, b: OrganizationMember | PlainMessage<OrganizationMember> | undefined): boolean {
    return proto3.util.equals(OrganizationMember, a, b);
  }
}

/**
 * @generated from message gitpod.v1.InviteDomains
 */
export class InviteDomains extends Message<InviteDomains> {
  /**
   * domains is the list of domains that are allowed to join the organization
   *
   * @generated from field: repeated string domains = 1;
   */
  domains: string[] = [];

  constructor(data?: PartialMessage<InviteDomains>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.InviteDomains";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InviteDomains {
    return new InviteDomains().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InviteDomains {
    return new InviteDomains().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InviteDomains {
    return new InviteDomains().fromJsonString(jsonString, options);
  }

  static equals(a: InviteDomains | PlainMessage<InviteDomains> | undefined, b: InviteDomains | PlainMessage<InviteDomains> | undefined): boolean {
    return proto3.util.equals(InviteDomains, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSSOConfigurationRequest
 */
export class CreateSSOConfigurationRequest extends Message<CreateSSOConfigurationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * client_id is the client ID of the OIDC application set on the IdP
   *
   * @generated from field: string client_id = 2;
   */
  clientId = "";

  /**
   * client_secret is the client secret of the OIDC application set on the IdP
   *
   * @generated from field: string client_secret = 3;
   */
  clientSecret = "";

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: string issuer_url = 4;
   */
  issuerUrl = "";

  /**
   * email_domain is the domain that is allowed to sign in to the organization
   *
   * @generated from field: optional string email_domain = 5;
   */
  emailDomain?: string;

  /**
   * @generated from field: repeated string email_domains = 6;
   */
  emailDomains: string[] = [];

  /**
   * @generated from field: string display_name = 7;
   */
  displayName = "";

  constructor(data?: PartialMessage<CreateSSOConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSSOConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "issuer_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email_domain", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "email_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSSOConfigurationRequest {
    return new CreateSSOConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSSOConfigurationRequest {
    return new CreateSSOConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSSOConfigurationRequest {
    return new CreateSSOConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSSOConfigurationRequest | PlainMessage<CreateSSOConfigurationRequest> | undefined, b: CreateSSOConfigurationRequest | PlainMessage<CreateSSOConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(CreateSSOConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSSOConfigurationResponse
 */
export class CreateSSOConfigurationResponse extends Message<CreateSSOConfigurationResponse> {
  /**
   * sso_configuration is the created SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfiguration sso_configuration = 1;
   */
  ssoConfiguration?: SSOConfiguration;

  constructor(data?: PartialMessage<CreateSSOConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSSOConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sso_configuration", kind: "message", T: SSOConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSSOConfigurationResponse {
    return new CreateSSOConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSSOConfigurationResponse {
    return new CreateSSOConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSSOConfigurationResponse {
    return new CreateSSOConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSSOConfigurationResponse | PlainMessage<CreateSSOConfigurationResponse> | undefined, b: CreateSSOConfigurationResponse | PlainMessage<CreateSSOConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(CreateSSOConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SSOConfiguration
 */
export class SSOConfiguration extends Message<SSOConfiguration> {
  /**
   * id is the unique identifier of the SSO configuration
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * client_id is the client ID of the OIDC application set on the IdP
   *
   * @generated from field: string client_id = 3;
   */
  clientId = "";

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: string issuer_url = 4;
   */
  issuerUrl = "";

  /**
   * state is the state of the SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfigurationState state = 5;
   */
  state = SSOConfigurationState.SSO_CONFIGURATION_STATE_UNSPECIFIED;

  /**
   * claims are key/value pairs that defines a mapping of claims issued by the IdP.
   *
   * @generated from field: map<string, string> claims = 6;
   */
  claims: { [key: string]: string } = {};

  /**
   * @generated from field: string email_domain = 7;
   */
  emailDomain = "";

  /**
   * provider_type defines the type of the SSO configuration
   *
   * @generated from field: gitpod.v1.SSOConfiguration.ProviderType provider_type = 8;
   */
  providerType = SSOConfiguration_ProviderType.UNSPECIFIED;

  /**
   * @generated from field: repeated string email_domains = 9;
   */
  emailDomains: string[] = [];

  /**
   * @generated from field: string display_name = 10;
   */
  displayName = "";

  constructor(data?: PartialMessage<SSOConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SSOConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "issuer_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "enum", T: proto3.getEnumType(SSOConfigurationState) },
    { no: 6, name: "claims", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "email_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "provider_type", kind: "enum", T: proto3.getEnumType(SSOConfiguration_ProviderType) },
    { no: 9, name: "email_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SSOConfiguration {
    return new SSOConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SSOConfiguration {
    return new SSOConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SSOConfiguration {
    return new SSOConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: SSOConfiguration | PlainMessage<SSOConfiguration> | undefined, b: SSOConfiguration | PlainMessage<SSOConfiguration> | undefined): boolean {
    return proto3.util.equals(SSOConfiguration, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.SSOConfiguration.ProviderType
 */
export enum SSOConfiguration_ProviderType {
  /**
   * @generated from enum value: PROVIDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROVIDER_TYPE_BUILTIN = 1;
   */
  BUILTIN = 1,

  /**
   * @generated from enum value: PROVIDER_TYPE_CUSTOM = 2;
   */
  CUSTOM = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SSOConfiguration_ProviderType)
proto3.util.setEnumType(SSOConfiguration_ProviderType, "gitpod.v1.SSOConfiguration.ProviderType", [
  { no: 0, name: "PROVIDER_TYPE_UNSPECIFIED" },
  { no: 1, name: "PROVIDER_TYPE_BUILTIN" },
  { no: 2, name: "PROVIDER_TYPE_CUSTOM" },
]);

/**
 * @generated from message gitpod.v1.GetSSOConfigurationRequest
 */
export class GetSSOConfigurationRequest extends Message<GetSSOConfigurationRequest> {
  /**
   * sso_configuration_id is the ID of the SSO configuration to get
   *
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId = "";

  constructor(data?: PartialMessage<GetSSOConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSSOConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSSOConfigurationRequest {
    return new GetSSOConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSSOConfigurationRequest {
    return new GetSSOConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSSOConfigurationRequest {
    return new GetSSOConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSSOConfigurationRequest | PlainMessage<GetSSOConfigurationRequest> | undefined, b: GetSSOConfigurationRequest | PlainMessage<GetSSOConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(GetSSOConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetSSOConfigurationResponse
 */
export class GetSSOConfigurationResponse extends Message<GetSSOConfigurationResponse> {
  /**
   * sso_configuration is the SSO configuration identified by the ID
   *
   * @generated from field: gitpod.v1.SSOConfiguration sso_configuration = 1;
   */
  ssoConfiguration?: SSOConfiguration;

  constructor(data?: PartialMessage<GetSSOConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSSOConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sso_configuration", kind: "message", T: SSOConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSSOConfigurationResponse {
    return new GetSSOConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSSOConfigurationResponse {
    return new GetSSOConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSSOConfigurationResponse {
    return new GetSSOConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSSOConfigurationResponse | PlainMessage<GetSSOConfigurationResponse> | undefined, b: GetSSOConfigurationResponse | PlainMessage<GetSSOConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(GetSSOConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSSOConfigurationsRequest
 */
export class ListSSOConfigurationsRequest extends Message<ListSSOConfigurationsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * organization_id is the ID of the organization to list SSO configurations for.
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  constructor(data?: PartialMessage<ListSSOConfigurationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSSOConfigurationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSSOConfigurationsRequest {
    return new ListSSOConfigurationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSSOConfigurationsRequest {
    return new ListSSOConfigurationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSSOConfigurationsRequest {
    return new ListSSOConfigurationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSSOConfigurationsRequest | PlainMessage<ListSSOConfigurationsRequest> | undefined, b: ListSSOConfigurationsRequest | PlainMessage<ListSSOConfigurationsRequest> | undefined): boolean {
    return proto3.util.equals(ListSSOConfigurationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSSOConfigurationsResponse
 */
export class ListSSOConfigurationsResponse extends Message<ListSSOConfigurationsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * sso_configurations are the SSO configurations for the organization
   *
   * @generated from field: repeated gitpod.v1.SSOConfiguration sso_configurations = 2;
   */
  ssoConfigurations: SSOConfiguration[] = [];

  constructor(data?: PartialMessage<ListSSOConfigurationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSSOConfigurationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "sso_configurations", kind: "message", T: SSOConfiguration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSSOConfigurationsResponse {
    return new ListSSOConfigurationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSSOConfigurationsResponse {
    return new ListSSOConfigurationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSSOConfigurationsResponse {
    return new ListSSOConfigurationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSSOConfigurationsResponse | PlainMessage<ListSSOConfigurationsResponse> | undefined, b: ListSSOConfigurationsResponse | PlainMessage<ListSSOConfigurationsResponse> | undefined): boolean {
    return proto3.util.equals(ListSSOConfigurationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSSOConfigurationRequest
 */
export class UpdateSSOConfigurationRequest extends Message<UpdateSSOConfigurationRequest> {
  /**
   * sso_configuration_id is the ID of the SSO configuration to update
   *
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId = "";

  /**
   * client_id is the client ID of the SSO provider
   *
   * @generated from field: optional string client_id = 2;
   */
  clientId?: string;

  /**
   * client_secret is the client secret of the SSO provider
   *
   * @generated from field: optional string client_secret = 3;
   */
  clientSecret?: string;

  /**
   * issuer_url is the URL of the IdP issuer
   *
   * @generated from field: optional string issuer_url = 4;
   */
  issuerUrl?: string;

  /**
   * state is the state of the SSO configuration
   *
   * @generated from field: optional gitpod.v1.SSOConfigurationState state = 5;
   */
  state?: SSOConfigurationState;

  /**
   * claims are key/value pairs that defines a mapping of claims issued by the IdP.
   *
   * @generated from field: map<string, string> claims = 6;
   */
  claims: { [key: string]: string } = {};

  /**
   * @generated from field: optional string email_domain = 7;
   */
  emailDomain?: string;

  /**
   * @generated from field: repeated string email_domains = 9;
   */
  emailDomains: string[] = [];

  /**
   * @generated from field: optional string display_name = 10;
   */
  displayName?: string;

  constructor(data?: PartialMessage<UpdateSSOConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSSOConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "issuer_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "state", kind: "enum", T: proto3.getEnumType(SSOConfigurationState), opt: true },
    { no: 6, name: "claims", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "email_domain", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "email_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSSOConfigurationRequest {
    return new UpdateSSOConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSSOConfigurationRequest {
    return new UpdateSSOConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSSOConfigurationRequest {
    return new UpdateSSOConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSSOConfigurationRequest | PlainMessage<UpdateSSOConfigurationRequest> | undefined, b: UpdateSSOConfigurationRequest | PlainMessage<UpdateSSOConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSSOConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSSOConfigurationResponse
 */
export class UpdateSSOConfigurationResponse extends Message<UpdateSSOConfigurationResponse> {
  constructor(data?: PartialMessage<UpdateSSOConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSSOConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSSOConfigurationResponse {
    return new UpdateSSOConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSSOConfigurationResponse {
    return new UpdateSSOConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSSOConfigurationResponse {
    return new UpdateSSOConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSSOConfigurationResponse | PlainMessage<UpdateSSOConfigurationResponse> | undefined, b: UpdateSSOConfigurationResponse | PlainMessage<UpdateSSOConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSSOConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSSOConfigurationRequest
 */
export class DeleteSSOConfigurationRequest extends Message<DeleteSSOConfigurationRequest> {
  /**
   * @generated from field: string sso_configuration_id = 1;
   */
  ssoConfigurationId = "";

  constructor(data?: PartialMessage<DeleteSSOConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSSOConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSSOConfigurationRequest {
    return new DeleteSSOConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSSOConfigurationRequest {
    return new DeleteSSOConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSSOConfigurationRequest {
    return new DeleteSSOConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSSOConfigurationRequest | PlainMessage<DeleteSSOConfigurationRequest> | undefined, b: DeleteSSOConfigurationRequest | PlainMessage<DeleteSSOConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteSSOConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSSOConfigurationResponse
 */
export class DeleteSSOConfigurationResponse extends Message<DeleteSSOConfigurationResponse> {
  constructor(data?: PartialMessage<DeleteSSOConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSSOConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSSOConfigurationResponse {
    return new DeleteSSOConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSSOConfigurationResponse {
    return new DeleteSSOConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSSOConfigurationResponse {
    return new DeleteSSOConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSSOConfigurationResponse | PlainMessage<DeleteSSOConfigurationResponse> | undefined, b: DeleteSSOConfigurationResponse | PlainMessage<DeleteSSOConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteSSOConfigurationResponse, a, b);
  }
}

/**
 * SCIMConfiguration represents a SCIM 2.0 provisioning configuration
 *
 * @generated from message gitpod.v1.SCIMConfiguration
 */
export class SCIMConfiguration extends Message<SCIMConfiguration> {
  /**
   * id is the unique identifier of the SCIM configuration
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * organization_id is the ID of the organization this SCIM configuration belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * enabled indicates if SCIM provisioning is active
   *
   * @generated from field: bool enabled = 4;
   */
  enabled = false;

  /**
   * sso_configuration_id is the linked SSO configuration (optional)
   *
   * @generated from field: string sso_configuration_id = 5;
   */
  ssoConfigurationId = "";

  /**
   * created_at is when the SCIM configuration was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the SCIM configuration was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * token_expires_at is when the current SCIM token expires
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 8;
   */
  tokenExpiresAt?: Timestamp;

  constructor(data?: PartialMessage<SCIMConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SCIMConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "updated_at", kind: "message", T: Timestamp },
    { no: 8, name: "token_expires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SCIMConfiguration {
    return new SCIMConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SCIMConfiguration {
    return new SCIMConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SCIMConfiguration {
    return new SCIMConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: SCIMConfiguration | PlainMessage<SCIMConfiguration> | undefined, b: SCIMConfiguration | PlainMessage<SCIMConfiguration> | undefined): boolean {
    return proto3.util.equals(SCIMConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSCIMConfigurationRequest
 */
export class CreateSCIMConfigurationRequest extends Message<CreateSCIMConfigurationRequest> {
  /**
   * organization_id is the ID of the organization to create the SCIM configuration for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * sso_configuration_id is the SSO configuration to link (required for user provisioning)
   *
   * @generated from field: string sso_configuration_id = 3;
   */
  ssoConfigurationId = "";

  /**
   * token_expires_in is the duration until the token expires.
   * Defaults to 1 year. Minimum 1 day, maximum 2 years.
   *
   * @generated from field: optional google.protobuf.Duration token_expires_in = 4;
   */
  tokenExpiresIn?: Duration;

  constructor(data?: PartialMessage<CreateSCIMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSCIMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "token_expires_in", kind: "message", T: Duration, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSCIMConfigurationRequest {
    return new CreateSCIMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSCIMConfigurationRequest {
    return new CreateSCIMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSCIMConfigurationRequest {
    return new CreateSCIMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSCIMConfigurationRequest | PlainMessage<CreateSCIMConfigurationRequest> | undefined, b: CreateSCIMConfigurationRequest | PlainMessage<CreateSCIMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(CreateSCIMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSCIMConfigurationResponse
 */
export class CreateSCIMConfigurationResponse extends Message<CreateSCIMConfigurationResponse> {
  /**
   * scim_configuration is the created SCIM configuration
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;

  /**
   * token is the bearer token for SCIM API authentication.
   * This is only returned once during creation - store it securely.
   *
   * @generated from field: string token = 2;
   */
  token = "";

  /**
   * token_expires_at is when the token will expire
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 3;
   */
  tokenExpiresAt?: Timestamp;

  constructor(data?: PartialMessage<CreateSCIMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSCIMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration", kind: "message", T: SCIMConfiguration },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "token_expires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSCIMConfigurationResponse {
    return new CreateSCIMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSCIMConfigurationResponse {
    return new CreateSCIMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSCIMConfigurationResponse {
    return new CreateSCIMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSCIMConfigurationResponse | PlainMessage<CreateSCIMConfigurationResponse> | undefined, b: CreateSCIMConfigurationResponse | PlainMessage<CreateSCIMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(CreateSCIMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetSCIMConfigurationRequest
 */
export class GetSCIMConfigurationRequest extends Message<GetSCIMConfigurationRequest> {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to get
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId = "";

  constructor(data?: PartialMessage<GetSCIMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSCIMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSCIMConfigurationRequest {
    return new GetSCIMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSCIMConfigurationRequest {
    return new GetSCIMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSCIMConfigurationRequest {
    return new GetSCIMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSCIMConfigurationRequest | PlainMessage<GetSCIMConfigurationRequest> | undefined, b: GetSCIMConfigurationRequest | PlainMessage<GetSCIMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(GetSCIMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetSCIMConfigurationResponse
 */
export class GetSCIMConfigurationResponse extends Message<GetSCIMConfigurationResponse> {
  /**
   * scim_configuration is the SCIM configuration identified by the ID
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;

  constructor(data?: PartialMessage<GetSCIMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSCIMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration", kind: "message", T: SCIMConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSCIMConfigurationResponse {
    return new GetSCIMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSCIMConfigurationResponse {
    return new GetSCIMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSCIMConfigurationResponse {
    return new GetSCIMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSCIMConfigurationResponse | PlainMessage<GetSCIMConfigurationResponse> | undefined, b: GetSCIMConfigurationResponse | PlainMessage<GetSCIMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(GetSCIMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSCIMConfigurationsRequest
 */
export class ListSCIMConfigurationsRequest extends Message<ListSCIMConfigurationsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListSCIMConfigurationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSCIMConfigurationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSCIMConfigurationsRequest {
    return new ListSCIMConfigurationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSCIMConfigurationsRequest {
    return new ListSCIMConfigurationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSCIMConfigurationsRequest {
    return new ListSCIMConfigurationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSCIMConfigurationsRequest | PlainMessage<ListSCIMConfigurationsRequest> | undefined, b: ListSCIMConfigurationsRequest | PlainMessage<ListSCIMConfigurationsRequest> | undefined): boolean {
    return proto3.util.equals(ListSCIMConfigurationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSCIMConfigurationsResponse
 */
export class ListSCIMConfigurationsResponse extends Message<ListSCIMConfigurationsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * scim_configurations are the SCIM configurations for the organization
   *
   * @generated from field: repeated gitpod.v1.SCIMConfiguration scim_configurations = 2;
   */
  scimConfigurations: SCIMConfiguration[] = [];

  constructor(data?: PartialMessage<ListSCIMConfigurationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSCIMConfigurationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "scim_configurations", kind: "message", T: SCIMConfiguration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSCIMConfigurationsResponse {
    return new ListSCIMConfigurationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSCIMConfigurationsResponse {
    return new ListSCIMConfigurationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSCIMConfigurationsResponse {
    return new ListSCIMConfigurationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSCIMConfigurationsResponse | PlainMessage<ListSCIMConfigurationsResponse> | undefined, b: ListSCIMConfigurationsResponse | PlainMessage<ListSCIMConfigurationsResponse> | undefined): boolean {
    return proto3.util.equals(ListSCIMConfigurationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSCIMConfigurationRequest
 */
export class UpdateSCIMConfigurationRequest extends Message<UpdateSCIMConfigurationRequest> {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to update
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId = "";

  /**
   * name is a human-readable name for the SCIM configuration
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * enabled controls whether SCIM provisioning is active
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;

  /**
   * sso_configuration_id is the SSO configuration to link
   *
   * @generated from field: optional string sso_configuration_id = 4;
   */
  ssoConfigurationId?: string;

  constructor(data?: PartialMessage<UpdateSCIMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSCIMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "sso_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSCIMConfigurationRequest {
    return new UpdateSCIMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSCIMConfigurationRequest {
    return new UpdateSCIMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSCIMConfigurationRequest {
    return new UpdateSCIMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSCIMConfigurationRequest | PlainMessage<UpdateSCIMConfigurationRequest> | undefined, b: UpdateSCIMConfigurationRequest | PlainMessage<UpdateSCIMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSCIMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSCIMConfigurationResponse
 */
export class UpdateSCIMConfigurationResponse extends Message<UpdateSCIMConfigurationResponse> {
  /**
   * scim_configuration is the updated SCIM configuration
   *
   * @generated from field: gitpod.v1.SCIMConfiguration scim_configuration = 1;
   */
  scimConfiguration?: SCIMConfiguration;

  constructor(data?: PartialMessage<UpdateSCIMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSCIMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration", kind: "message", T: SCIMConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSCIMConfigurationResponse {
    return new UpdateSCIMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSCIMConfigurationResponse {
    return new UpdateSCIMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSCIMConfigurationResponse {
    return new UpdateSCIMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSCIMConfigurationResponse | PlainMessage<UpdateSCIMConfigurationResponse> | undefined, b: UpdateSCIMConfigurationResponse | PlainMessage<UpdateSCIMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSCIMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSCIMConfigurationRequest
 */
export class DeleteSCIMConfigurationRequest extends Message<DeleteSCIMConfigurationRequest> {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to delete
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId = "";

  constructor(data?: PartialMessage<DeleteSCIMConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSCIMConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSCIMConfigurationRequest {
    return new DeleteSCIMConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSCIMConfigurationRequest {
    return new DeleteSCIMConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSCIMConfigurationRequest {
    return new DeleteSCIMConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSCIMConfigurationRequest | PlainMessage<DeleteSCIMConfigurationRequest> | undefined, b: DeleteSCIMConfigurationRequest | PlainMessage<DeleteSCIMConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteSCIMConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSCIMConfigurationResponse
 */
export class DeleteSCIMConfigurationResponse extends Message<DeleteSCIMConfigurationResponse> {
  constructor(data?: PartialMessage<DeleteSCIMConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSCIMConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSCIMConfigurationResponse {
    return new DeleteSCIMConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSCIMConfigurationResponse {
    return new DeleteSCIMConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSCIMConfigurationResponse {
    return new DeleteSCIMConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSCIMConfigurationResponse | PlainMessage<DeleteSCIMConfigurationResponse> | undefined, b: DeleteSCIMConfigurationResponse | PlainMessage<DeleteSCIMConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteSCIMConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RegenerateSCIMTokenRequest
 */
export class RegenerateSCIMTokenRequest extends Message<RegenerateSCIMTokenRequest> {
  /**
   * scim_configuration_id is the ID of the SCIM configuration to regenerate token for
   *
   * @generated from field: string scim_configuration_id = 1;
   */
  scimConfigurationId = "";

  /**
   * token_expires_in is the duration until the new token expires.
   * If not specified, uses the same duration as the previous token.
   *
   * @generated from field: optional google.protobuf.Duration token_expires_in = 2;
   */
  tokenExpiresIn?: Duration;

  constructor(data?: PartialMessage<RegenerateSCIMTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RegenerateSCIMTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scim_configuration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token_expires_in", kind: "message", T: Duration, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegenerateSCIMTokenRequest {
    return new RegenerateSCIMTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegenerateSCIMTokenRequest {
    return new RegenerateSCIMTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegenerateSCIMTokenRequest {
    return new RegenerateSCIMTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegenerateSCIMTokenRequest | PlainMessage<RegenerateSCIMTokenRequest> | undefined, b: RegenerateSCIMTokenRequest | PlainMessage<RegenerateSCIMTokenRequest> | undefined): boolean {
    return proto3.util.equals(RegenerateSCIMTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RegenerateSCIMTokenResponse
 */
export class RegenerateSCIMTokenResponse extends Message<RegenerateSCIMTokenResponse> {
  /**
   * token is the new bearer token for SCIM API authentication.
   * This invalidates the previous token - store it securely.
   *
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * token_expires_at is when the new token will expire
   *
   * @generated from field: google.protobuf.Timestamp token_expires_at = 2;
   */
  tokenExpiresAt?: Timestamp;

  constructor(data?: PartialMessage<RegenerateSCIMTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RegenerateSCIMTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token_expires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegenerateSCIMTokenResponse {
    return new RegenerateSCIMTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegenerateSCIMTokenResponse {
    return new RegenerateSCIMTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegenerateSCIMTokenResponse {
    return new RegenerateSCIMTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RegenerateSCIMTokenResponse | PlainMessage<RegenerateSCIMTokenResponse> | undefined, b: RegenerateSCIMTokenResponse | PlainMessage<RegenerateSCIMTokenResponse> | undefined): boolean {
    return proto3.util.equals(RegenerateSCIMTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DomainVerification
 */
export class DomainVerification extends Message<DomainVerification> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * @generated from field: string domain = 3;
   */
  domain = "";

  /**
   * @generated from field: gitpod.v1.DomainVerificationState state = 4;
   */
  state = DomainVerificationState.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp verified_at = 5;
   */
  verifiedAt?: Timestamp;

  /**
   * @generated from field: string verification_token = 6;
   */
  verificationToken = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  constructor(data?: PartialMessage<DomainVerification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DomainVerification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "state", kind: "enum", T: proto3.getEnumType(DomainVerificationState) },
    { no: 5, name: "verified_at", kind: "message", T: Timestamp },
    { no: 6, name: "verification_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DomainVerification {
    return new DomainVerification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DomainVerification {
    return new DomainVerification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DomainVerification {
    return new DomainVerification().fromJsonString(jsonString, options);
  }

  static equals(a: DomainVerification | PlainMessage<DomainVerification> | undefined, b: DomainVerification | PlainMessage<DomainVerification> | undefined): boolean {
    return proto3.util.equals(DomainVerification, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateDomainVerificationRequest
 */
export class CreateDomainVerificationRequest extends Message<CreateDomainVerificationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string domain = 2;
   */
  domain = "";

  constructor(data?: PartialMessage<CreateDomainVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateDomainVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDomainVerificationRequest {
    return new CreateDomainVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDomainVerificationRequest {
    return new CreateDomainVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDomainVerificationRequest {
    return new CreateDomainVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDomainVerificationRequest | PlainMessage<CreateDomainVerificationRequest> | undefined, b: CreateDomainVerificationRequest | PlainMessage<CreateDomainVerificationRequest> | undefined): boolean {
    return proto3.util.equals(CreateDomainVerificationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateDomainVerificationResponse
 */
export class CreateDomainVerificationResponse extends Message<CreateDomainVerificationResponse> {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;

  constructor(data?: PartialMessage<CreateDomainVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateDomainVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification", kind: "message", T: DomainVerification },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDomainVerificationResponse {
    return new CreateDomainVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDomainVerificationResponse {
    return new CreateDomainVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDomainVerificationResponse {
    return new CreateDomainVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDomainVerificationResponse | PlainMessage<CreateDomainVerificationResponse> | undefined, b: CreateDomainVerificationResponse | PlainMessage<CreateDomainVerificationResponse> | undefined): boolean {
    return proto3.util.equals(CreateDomainVerificationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetDomainVerificationRequest
 */
export class GetDomainVerificationRequest extends Message<GetDomainVerificationRequest> {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId = "";

  constructor(data?: PartialMessage<GetDomainVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetDomainVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDomainVerificationRequest {
    return new GetDomainVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDomainVerificationRequest {
    return new GetDomainVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDomainVerificationRequest {
    return new GetDomainVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDomainVerificationRequest | PlainMessage<GetDomainVerificationRequest> | undefined, b: GetDomainVerificationRequest | PlainMessage<GetDomainVerificationRequest> | undefined): boolean {
    return proto3.util.equals(GetDomainVerificationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetDomainVerificationResponse
 */
export class GetDomainVerificationResponse extends Message<GetDomainVerificationResponse> {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;

  constructor(data?: PartialMessage<GetDomainVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetDomainVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification", kind: "message", T: DomainVerification },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDomainVerificationResponse {
    return new GetDomainVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDomainVerificationResponse {
    return new GetDomainVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDomainVerificationResponse {
    return new GetDomainVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDomainVerificationResponse | PlainMessage<GetDomainVerificationResponse> | undefined, b: GetDomainVerificationResponse | PlainMessage<GetDomainVerificationResponse> | undefined): boolean {
    return proto3.util.equals(GetDomainVerificationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListDomainVerificationsRequest
 */
export class ListDomainVerificationsRequest extends Message<ListDomainVerificationsRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListDomainVerificationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListDomainVerificationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDomainVerificationsRequest {
    return new ListDomainVerificationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDomainVerificationsRequest {
    return new ListDomainVerificationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDomainVerificationsRequest {
    return new ListDomainVerificationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDomainVerificationsRequest | PlainMessage<ListDomainVerificationsRequest> | undefined, b: ListDomainVerificationsRequest | PlainMessage<ListDomainVerificationsRequest> | undefined): boolean {
    return proto3.util.equals(ListDomainVerificationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListDomainVerificationsResponse
 */
export class ListDomainVerificationsResponse extends Message<ListDomainVerificationsResponse> {
  /**
   * @generated from field: repeated gitpod.v1.DomainVerification domain_verifications = 1;
   */
  domainVerifications: DomainVerification[] = [];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  constructor(data?: PartialMessage<ListDomainVerificationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListDomainVerificationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verifications", kind: "message", T: DomainVerification, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDomainVerificationsResponse {
    return new ListDomainVerificationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDomainVerificationsResponse {
    return new ListDomainVerificationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDomainVerificationsResponse {
    return new ListDomainVerificationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDomainVerificationsResponse | PlainMessage<ListDomainVerificationsResponse> | undefined, b: ListDomainVerificationsResponse | PlainMessage<ListDomainVerificationsResponse> | undefined): boolean {
    return proto3.util.equals(ListDomainVerificationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.VerifyDomainRequest
 */
export class VerifyDomainRequest extends Message<VerifyDomainRequest> {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId = "";

  constructor(data?: PartialMessage<VerifyDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.VerifyDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyDomainRequest {
    return new VerifyDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyDomainRequest {
    return new VerifyDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyDomainRequest {
    return new VerifyDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyDomainRequest | PlainMessage<VerifyDomainRequest> | undefined, b: VerifyDomainRequest | PlainMessage<VerifyDomainRequest> | undefined): boolean {
    return proto3.util.equals(VerifyDomainRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.VerifyDomainResponse
 */
export class VerifyDomainResponse extends Message<VerifyDomainResponse> {
  /**
   * @generated from field: gitpod.v1.DomainVerification domain_verification = 1;
   */
  domainVerification?: DomainVerification;

  constructor(data?: PartialMessage<VerifyDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.VerifyDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification", kind: "message", T: DomainVerification },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyDomainResponse {
    return new VerifyDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyDomainResponse {
    return new VerifyDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyDomainResponse {
    return new VerifyDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyDomainResponse | PlainMessage<VerifyDomainResponse> | undefined, b: VerifyDomainResponse | PlainMessage<VerifyDomainResponse> | undefined): boolean {
    return proto3.util.equals(VerifyDomainResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteDomainVerificationRequest
 */
export class DeleteDomainVerificationRequest extends Message<DeleteDomainVerificationRequest> {
  /**
   * @generated from field: string domain_verification_id = 1;
   */
  domainVerificationId = "";

  constructor(data?: PartialMessage<DeleteDomainVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteDomainVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain_verification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDomainVerificationRequest {
    return new DeleteDomainVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDomainVerificationRequest {
    return new DeleteDomainVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDomainVerificationRequest {
    return new DeleteDomainVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDomainVerificationRequest | PlainMessage<DeleteDomainVerificationRequest> | undefined, b: DeleteDomainVerificationRequest | PlainMessage<DeleteDomainVerificationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteDomainVerificationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteDomainVerificationResponse
 */
export class DeleteDomainVerificationResponse extends Message<DeleteDomainVerificationResponse> {
  constructor(data?: PartialMessage<DeleteDomainVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteDomainVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDomainVerificationResponse {
    return new DeleteDomainVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDomainVerificationResponse {
    return new DeleteDomainVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDomainVerificationResponse {
    return new DeleteDomainVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDomainVerificationResponse | PlainMessage<DeleteDomainVerificationResponse> | undefined, b: DeleteDomainVerificationResponse | PlainMessage<DeleteDomainVerificationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteDomainVerificationResponse, a, b);
  }
}

/**
 * OrganizationTierFailedPreconditionDetails is a precondition failure details message used when a feature requires a higher Organization tier.
 *
 * @generated from message gitpod.v1.OrganizationTierFailedPreconditionDetails
 */
export class OrganizationTierFailedPreconditionDetails extends Message<OrganizationTierFailedPreconditionDetails> {
  /**
   * message is the message to display to the user
   *
   * @generated from field: string message = 1;
   */
  message = "";

  /**
   * required_tier is the tier that is required to use the feature
   *
   * @generated from field: gitpod.v1.OrganizationTier required_tier = 2;
   */
  requiredTier = OrganizationTier.UNSPECIFIED;

  constructor(data?: PartialMessage<OrganizationTierFailedPreconditionDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.OrganizationTierFailedPreconditionDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "required_tier", kind: "enum", T: proto3.getEnumType(OrganizationTier) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrganizationTierFailedPreconditionDetails {
    return new OrganizationTierFailedPreconditionDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrganizationTierFailedPreconditionDetails {
    return new OrganizationTierFailedPreconditionDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrganizationTierFailedPreconditionDetails {
    return new OrganizationTierFailedPreconditionDetails().fromJsonString(jsonString, options);
  }

  static equals(a: OrganizationTierFailedPreconditionDetails | PlainMessage<OrganizationTierFailedPreconditionDetails> | undefined, b: OrganizationTierFailedPreconditionDetails | PlainMessage<OrganizationTierFailedPreconditionDetails> | undefined): boolean {
    return proto3.util.equals(OrganizationTierFailedPreconditionDetails, a, b);
  }
}

/**
 * @generated from message gitpod.v1.OrganizationPolicies
 */
export class OrganizationPolicies extends Message<OrganizationPolicies> {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * maximum_environment_timeout controls the maximum timeout allowed for environments in seconds.
   * 0 means no limit (never). Minimum duration is 30 minutes (1800 seconds).
   *
   * @generated from field: google.protobuf.Duration maximum_environment_timeout = 2;
   */
  maximumEnvironmentTimeout?: Duration;

  /**
   * members_require_projects controls whether environments can only be created from projects by non-admin users
   *
   * @generated from field: bool members_require_projects = 3;
   */
  membersRequireProjects = false;

  /**
   * members_create_projects controls whether members can create projects
   *
   * @generated from field: bool members_create_projects = 4;
   */
  membersCreateProjects = false;

  /**
   * allowed_editor_ids is the list of editor IDs that are allowed to be used in the organization
   *
   * @generated from field: repeated string allowed_editor_ids = 5;
   */
  allowedEditorIds: string[] = [];

  /**
   * default_editor_id is the default editor ID to be used when a user doesn't specify one
   *
   * @generated from field: string default_editor_id = 6;
   */
  defaultEditorId = "";

  /**
   * allow_local_runners controls whether local runners are allowed to be used in the organization
   *
   * @generated from field: bool allow_local_runners = 7;
   */
  allowLocalRunners = false;

  /**
   * maximum_running_environments_per_user limits simultaneously running environments per user
   *
   * @generated from field: int64 maximum_running_environments_per_user = 8;
   */
  maximumRunningEnvironmentsPerUser = protoInt64.zero;

  /**
   * maximum_environments_per_user limits total environments (running or stopped) per user
   *
   * @generated from field: int64 maximum_environments_per_user = 9;
   */
  maximumEnvironmentsPerUser = protoInt64.zero;

  /**
   * default_environment_image is the default container image when none is defined in repo
   *
   * @generated from field: string default_environment_image = 10;
   */
  defaultEnvironmentImage = "";

  /**
   * port_sharing_disabled controls whether port sharing is disabled in the organization
   *
   * @generated from field: bool port_sharing_disabled = 11;
   */
  portSharingDisabled = false;

  /**
   * delete_archived_environments_after controls how long archived environments are kept before automatic deletion.
   * 0 means no automatic deletion. Maximum duration is 4 weeks (2419200 seconds).
   *
   * @generated from field: google.protobuf.Duration delete_archived_environments_after = 12;
   */
  deleteArchivedEnvironmentsAfter?: Duration;

  /**
   * agent_policy contains agent-specific policy settings
   *
   * @generated from field: gitpod.v1.AgentPolicy agent_policy = 13;
   */
  agentPolicy?: AgentPolicy;

  /**
   * maximum_environment_lifetime controls for how long environments are allowed to be reused.
   * 0 means no maximum lifetime. Maximum duration is 180 days (15552000 seconds).
   *
   * @generated from field: google.protobuf.Duration maximum_environment_lifetime = 14;
   */
  maximumEnvironmentLifetime?: Duration;

  /**
   * require_custom_domain_access controls whether users must access via custom domain
   * when one is configured. When true, access via app.gitpod.io is blocked.
   *
   * @generated from field: bool require_custom_domain_access = 15;
   */
  requireCustomDomainAccess = false;

  /**
   * editor_version_restrictions restricts which editor versions can be used.
   * Maps editor ID to version policy, editor_version_restrictions not set means no restrictions.
   * If empty or not set for an editor, we will use the latest version of the editor
   *
   * @generated from field: map<string, gitpod.v1.EditorVersionPolicy> editor_version_restrictions = 16;
   */
  editorVersionRestrictions: { [key: string]: EditorVersionPolicy } = {};

  /**
   * security_agent_policy contains security agent configuration for the organization.
   * When configured, security agents are automatically deployed to all environments.
   *
   * @generated from field: gitpod.v1.SecurityAgentPolicy security_agent_policy = 17;
   */
  securityAgentPolicy?: SecurityAgentPolicy;

  constructor(data?: PartialMessage<OrganizationPolicies>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.OrganizationPolicies";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "maximum_environment_timeout", kind: "message", T: Duration },
    { no: 3, name: "members_require_projects", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "members_create_projects", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "allowed_editor_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "default_editor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "allow_local_runners", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "maximum_running_environments_per_user", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "maximum_environments_per_user", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "default_environment_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "port_sharing_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "delete_archived_environments_after", kind: "message", T: Duration },
    { no: 13, name: "agent_policy", kind: "message", T: AgentPolicy },
    { no: 14, name: "maximum_environment_lifetime", kind: "message", T: Duration },
    { no: 15, name: "require_custom_domain_access", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "editor_version_restrictions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: EditorVersionPolicy} },
    { no: 17, name: "security_agent_policy", kind: "message", T: SecurityAgentPolicy },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrganizationPolicies {
    return new OrganizationPolicies().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrganizationPolicies {
    return new OrganizationPolicies().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrganizationPolicies {
    return new OrganizationPolicies().fromJsonString(jsonString, options);
  }

  static equals(a: OrganizationPolicies | PlainMessage<OrganizationPolicies> | undefined, b: OrganizationPolicies | PlainMessage<OrganizationPolicies> | undefined): boolean {
    return proto3.util.equals(OrganizationPolicies, a, b);
  }
}

/**
 * EditorVersionPolicy defines the version policy for a specific editor
 *
 * @generated from message gitpod.v1.EditorVersionPolicy
 */
export class EditorVersionPolicy extends Message<EditorVersionPolicy> {
  /**
   * allowed_versions lists the versions that are allowed
   * If empty, we will use the latest version of the editor
   *
   * Examples for JetBrains: `["2025.2", "2025.1", "2024.3"]`
   *
   * @generated from field: repeated string allowed_versions = 1;
   */
  allowedVersions: string[] = [];

  constructor(data?: PartialMessage<EditorVersionPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EditorVersionPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "allowed_versions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EditorVersionPolicy {
    return new EditorVersionPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EditorVersionPolicy {
    return new EditorVersionPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EditorVersionPolicy {
    return new EditorVersionPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: EditorVersionPolicy | PlainMessage<EditorVersionPolicy> | undefined, b: EditorVersionPolicy | PlainMessage<EditorVersionPolicy> | undefined): boolean {
    return proto3.util.equals(EditorVersionPolicy, a, b);
  }
}

/**
 * AgentPolicy contains agent-specific policy settings for an organization
 *
 * @generated from message gitpod.v1.AgentPolicy
 */
export class AgentPolicy extends Message<AgentPolicy> {
  /**
   * mcp_disabled controls whether MCP (Model Context Protocol) is disabled for agents
   *
   * @generated from field: bool mcp_disabled = 1;
   */
  mcpDisabled = false;

  /**
   * command_deny_list contains a list of commands that agents are not allowed to execute
   *
   * @generated from field: repeated string command_deny_list = 2;
   */
  commandDenyList: string[] = [];

  /**
   * scm_tools_disabled controls whether SCM (Source Control Management) tools are disabled for agents
   *
   * @generated from field: bool scm_tools_disabled = 3;
   */
  scmToolsDisabled = false;

  /**
   * scm_tools_allowed_group_id restricts SCM tools access to members of this group.
   * Empty means no restriction (all users can use SCM tools if not disabled).
   *
   * @generated from field: string scm_tools_allowed_group_id = 4;
   */
  scmToolsAllowedGroupId = "";

  constructor(data?: PartialMessage<AgentPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mcp_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "command_deny_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "scm_tools_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "scm_tools_allowed_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentPolicy {
    return new AgentPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentPolicy {
    return new AgentPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentPolicy {
    return new AgentPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: AgentPolicy | PlainMessage<AgentPolicy> | undefined, b: AgentPolicy | PlainMessage<AgentPolicy> | undefined): boolean {
    return proto3.util.equals(AgentPolicy, a, b);
  }
}

/**
 * SecurityAgentPolicy contains security agent configuration for an organization.
 * When enabled, security agents are automatically deployed to all environments.
 *
 * @generated from message gitpod.v1.SecurityAgentPolicy
 */
export class SecurityAgentPolicy extends Message<SecurityAgentPolicy> {
  /**
   * crowdstrike contains CrowdStrike Falcon configuration
   *
   * @generated from field: gitpod.v1.CrowdStrikeConfig crowdstrike = 1;
   */
  crowdstrike?: CrowdStrikeConfig;

  constructor(data?: PartialMessage<SecurityAgentPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SecurityAgentPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "crowdstrike", kind: "message", T: CrowdStrikeConfig },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SecurityAgentPolicy {
    return new SecurityAgentPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SecurityAgentPolicy {
    return new SecurityAgentPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SecurityAgentPolicy {
    return new SecurityAgentPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: SecurityAgentPolicy | PlainMessage<SecurityAgentPolicy> | undefined, b: SecurityAgentPolicy | PlainMessage<SecurityAgentPolicy> | undefined): boolean {
    return proto3.util.equals(SecurityAgentPolicy, a, b);
  }
}

/**
 * CrowdStrikeConfig configures CrowdStrike Falcon sensor deployment
 *
 * @generated from message gitpod.v1.CrowdStrikeConfig
 */
export class CrowdStrikeConfig extends Message<CrowdStrikeConfig> {
  /**
   * enabled controls whether CrowdStrike Falcon is deployed to environments
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * image is the CrowdStrike Falcon sensor container image reference
   *
   * @generated from field: string image = 2;
   */
  image = "";

  /**
   * cid_secret_id references an organization secret containing the Customer ID (CID).
   *
   * @generated from field: string cid_secret_id = 3;
   */
  cidSecretId = "";

  /**
   * tags are optional tags to apply to the Falcon sensor (comma-separated)
   *
   * @generated from field: string tags = 4;
   */
  tags = "";

  /**
   * additional_options contains additional FALCONCTL_OPT_* options as key-value pairs.
   * Keys should NOT include the FALCONCTL_OPT_ prefix.
   *
   * @generated from field: map<string, string> additional_options = 5;
   */
  additionalOptions: { [key: string]: string } = {};

  constructor(data?: PartialMessage<CrowdStrikeConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CrowdStrikeConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cid_secret_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "additional_options", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CrowdStrikeConfig {
    return new CrowdStrikeConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CrowdStrikeConfig {
    return new CrowdStrikeConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CrowdStrikeConfig {
    return new CrowdStrikeConfig().fromJsonString(jsonString, options);
  }

  static equals(a: CrowdStrikeConfig | PlainMessage<CrowdStrikeConfig> | undefined, b: CrowdStrikeConfig | PlainMessage<CrowdStrikeConfig> | undefined): boolean {
    return proto3.util.equals(CrowdStrikeConfig, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationPoliciesRequest
 */
export class GetOrganizationPoliciesRequest extends Message<GetOrganizationPoliciesRequest> {
  /**
   * organization_id is the ID of the organization to retrieve policies for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetOrganizationPoliciesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationPoliciesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationPoliciesRequest {
    return new GetOrganizationPoliciesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationPoliciesRequest {
    return new GetOrganizationPoliciesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationPoliciesRequest {
    return new GetOrganizationPoliciesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationPoliciesRequest | PlainMessage<GetOrganizationPoliciesRequest> | undefined, b: GetOrganizationPoliciesRequest | PlainMessage<GetOrganizationPoliciesRequest> | undefined): boolean {
    return proto3.util.equals(GetOrganizationPoliciesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetOrganizationPoliciesResponse
 */
export class GetOrganizationPoliciesResponse extends Message<GetOrganizationPoliciesResponse> {
  /**
   * @generated from field: gitpod.v1.OrganizationPolicies policies = 1;
   */
  policies?: OrganizationPolicies;

  constructor(data?: PartialMessage<GetOrganizationPoliciesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetOrganizationPoliciesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "policies", kind: "message", T: OrganizationPolicies },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrganizationPoliciesResponse {
    return new GetOrganizationPoliciesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrganizationPoliciesResponse {
    return new GetOrganizationPoliciesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrganizationPoliciesResponse {
    return new GetOrganizationPoliciesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrganizationPoliciesResponse | PlainMessage<GetOrganizationPoliciesResponse> | undefined, b: GetOrganizationPoliciesResponse | PlainMessage<GetOrganizationPoliciesResponse> | undefined): boolean {
    return proto3.util.equals(GetOrganizationPoliciesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest
 */
export class UpdateOrganizationPoliciesRequest extends Message<UpdateOrganizationPoliciesRequest> {
  /**
   * organization_id is the ID of the organization to update policies for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * maximum_environment_timeout controls the maximum timeout allowed for environments in seconds.
   * 0 means no limit (never). Minimum duration is 30 minutes (1800 seconds).
   *
   * @generated from field: optional google.protobuf.Duration maximum_environment_timeout = 2;
   */
  maximumEnvironmentTimeout?: Duration;

  /**
   * members_require_projects controls whether environments can only be created from projects by non-admin users
   *
   * @generated from field: optional bool members_require_projects = 3;
   */
  membersRequireProjects?: boolean;

  /**
   * members_create_projects controls whether members can create projects
   *
   * @generated from field: optional bool members_create_projects = 4;
   */
  membersCreateProjects?: boolean;

  /**
   * allowed_editor_ids is the list of editor IDs that are allowed to be used in the organization
   *
   * @generated from field: repeated string allowed_editor_ids = 5;
   */
  allowedEditorIds: string[] = [];

  /**
   * default_editor_id is the default editor ID to be used when a user doesn't specify one
   *
   * @generated from field: optional string default_editor_id = 6;
   */
  defaultEditorId?: string;

  /**
   * allow_local_runners controls whether local runners are allowed to be used in the organization
   *
   * @generated from field: optional bool allow_local_runners = 7;
   */
  allowLocalRunners?: boolean;

  /**
   * maximum_running_environments_per_user limits simultaneously running environments per user
   *
   * @generated from field: optional int64 maximum_running_environments_per_user = 8;
   */
  maximumRunningEnvironmentsPerUser?: bigint;

  /**
   * maximum_environments_per_user limits total environments (running or stopped) per user
   *
   * @generated from field: optional int64 maximum_environments_per_user = 9;
   */
  maximumEnvironmentsPerUser?: bigint;

  /**
   * default_environment_image is the default container image when none is defined in repo
   *
   * @generated from field: optional string default_environment_image = 10;
   */
  defaultEnvironmentImage?: string;

  /**
   * port_sharing_disabled controls whether port sharing is disabled in the organization
   *
   * @generated from field: optional bool port_sharing_disabled = 11;
   */
  portSharingDisabled?: boolean;

  /**
   * delete_archived_environments_after controls how long archived environments are kept before automatic deletion.
   * 0 means no automatic deletion. Maximum duration is 4 weeks (2419200 seconds).
   *
   * @generated from field: optional google.protobuf.Duration delete_archived_environments_after = 12;
   */
  deleteArchivedEnvironmentsAfter?: Duration;

  /**
   * agent_policy contains agent-specific policy settings
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy agent_policy = 13;
   */
  agentPolicy?: UpdateOrganizationPoliciesRequest_UpdateAgentPolicy;

  /**
   * maximum_environment_lifetime controls for how long environments are allowed to be reused.
   * 0 means no maximum lifetime. Maximum duration is 180 days (15552000 seconds).
   *
   * @generated from field: optional google.protobuf.Duration maximum_environment_lifetime = 14;
   */
  maximumEnvironmentLifetime?: Duration;

  /**
   * require_custom_domain_access controls whether users must access via custom domain
   * when one is configured. When true, access via app.gitpod.io is blocked.
   *
   * @generated from field: optional bool require_custom_domain_access = 15;
   */
  requireCustomDomainAccess?: boolean;

  /**
   * editor_version_restrictions restricts which editor versions can be used.
   * Maps editor ID to version policy with allowed major versions.
   *
   * @generated from field: map<string, gitpod.v1.EditorVersionPolicy> editor_version_restrictions = 16;
   */
  editorVersionRestrictions: { [key: string]: EditorVersionPolicy } = {};

  /**
   * security_agent_policy contains security agent configuration updates
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy security_agent_policy = 17;
   */
  securityAgentPolicy?: UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy;

  constructor(data?: PartialMessage<UpdateOrganizationPoliciesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationPoliciesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "maximum_environment_timeout", kind: "message", T: Duration, opt: true },
    { no: 3, name: "members_require_projects", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "members_create_projects", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "allowed_editor_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "default_editor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "allow_local_runners", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "maximum_running_environments_per_user", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "maximum_environments_per_user", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "default_environment_image", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "port_sharing_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 12, name: "delete_archived_environments_after", kind: "message", T: Duration, opt: true },
    { no: 13, name: "agent_policy", kind: "message", T: UpdateOrganizationPoliciesRequest_UpdateAgentPolicy, opt: true },
    { no: 14, name: "maximum_environment_lifetime", kind: "message", T: Duration, opt: true },
    { no: 15, name: "require_custom_domain_access", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 16, name: "editor_version_restrictions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: EditorVersionPolicy} },
    { no: 17, name: "security_agent_policy", kind: "message", T: UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationPoliciesRequest {
    return new UpdateOrganizationPoliciesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest {
    return new UpdateOrganizationPoliciesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest {
    return new UpdateOrganizationPoliciesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationPoliciesRequest | PlainMessage<UpdateOrganizationPoliciesRequest> | undefined, b: UpdateOrganizationPoliciesRequest | PlainMessage<UpdateOrganizationPoliciesRequest> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationPoliciesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy
 */
export class UpdateOrganizationPoliciesRequest_UpdateAgentPolicy extends Message<UpdateOrganizationPoliciesRequest_UpdateAgentPolicy> {
  /**
   * mcp_disabled controls whether MCP (Model Context Protocol) is disabled for agents
   *
   * @generated from field: optional bool mcp_disabled = 1;
   */
  mcpDisabled?: boolean;

  /**
   * command_deny_list contains a list of commands that agents are not allowed to execute
   *
   * @generated from field: repeated string command_deny_list = 2;
   */
  commandDenyList: string[] = [];

  /**
   * scm_tools_disabled controls whether SCM (Source Control Management) tools are disabled for agents
   *
   * @generated from field: optional bool scm_tools_disabled = 3;
   */
  scmToolsDisabled?: boolean;

  /**
   * scm_tools_allowed_group_id restricts SCM tools access to members of this group.
   * Empty means no restriction (all users can use SCM tools if not disabled).
   *
   * @generated from field: optional string scm_tools_allowed_group_id = 4;
   */
  scmToolsAllowedGroupId?: string;

  constructor(data?: PartialMessage<UpdateOrganizationPoliciesRequest_UpdateAgentPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateAgentPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mcp_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "command_deny_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "scm_tools_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "scm_tools_allowed_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationPoliciesRequest_UpdateAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateAgentPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateAgentPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateAgentPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationPoliciesRequest_UpdateAgentPolicy | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateAgentPolicy> | undefined, b: UpdateOrganizationPoliciesRequest_UpdateAgentPolicy | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateAgentPolicy> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationPoliciesRequest_UpdateAgentPolicy, a, b);
  }
}

/**
 * UpdateSecurityAgentPolicy contains security agent configuration updates
 *
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy
 */
export class UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy extends Message<UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy> {
  /**
   * crowdstrike contains CrowdStrike Falcon configuration updates
   *
   * @generated from field: optional gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig crowdstrike = 1;
   */
  crowdstrike?: UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig;

  constructor(data?: PartialMessage<UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateSecurityAgentPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "crowdstrike", kind: "message", T: UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy {
    return new UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy> | undefined, b: UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationPoliciesRequest_UpdateSecurityAgentPolicy, a, b);
  }
}

/**
 * UpdateCrowdStrikeConfig contains CrowdStrike Falcon configuration updates
 *
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig
 */
export class UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig extends Message<UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig> {
  /**
   * enabled controls whether CrowdStrike Falcon is deployed to environments
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * image is the CrowdStrike Falcon sensor container image reference
   *
   * @generated from field: optional string image = 2;
   */
  image?: string;

  /**
   * cid_secret_id references an organization secret containing the Customer ID (CID)
   *
   * @generated from field: optional string cid_secret_id = 3;
   */
  cidSecretId?: string;

  /**
   * tags are optional tags to apply to the Falcon sensor
   *
   * @generated from field: optional string tags = 4;
   */
  tags?: string;

  /**
   * additional_options contains additional FALCONCTL_OPT_* options as key-value pairs
   *
   * @generated from field: map<string, string> additional_options = 5;
   */
  additionalOptions: { [key: string]: string } = {};

  constructor(data?: PartialMessage<UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationPoliciesRequest.UpdateCrowdStrikeConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "cid_secret_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "additional_options", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig {
    return new UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig {
    return new UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig {
    return new UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig> | undefined, b: UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig | PlainMessage<UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationPoliciesRequest_UpdateCrowdStrikeConfig, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateOrganizationPoliciesResponse
 */
export class UpdateOrganizationPoliciesResponse extends Message<UpdateOrganizationPoliciesResponse> {
  constructor(data?: PartialMessage<UpdateOrganizationPoliciesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateOrganizationPoliciesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrganizationPoliciesResponse {
    return new UpdateOrganizationPoliciesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesResponse {
    return new UpdateOrganizationPoliciesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrganizationPoliciesResponse {
    return new UpdateOrganizationPoliciesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrganizationPoliciesResponse | PlainMessage<UpdateOrganizationPoliciesResponse> | undefined, b: UpdateOrganizationPoliciesResponse | PlainMessage<UpdateOrganizationPoliciesResponse> | undefined): boolean {
    return proto3.util.equals(UpdateOrganizationPoliciesResponse, a, b);
  }
}

/**
 * PolicyEnforcedFailedPreconditionDetails is a precondition failure details message used when a feature is limited by the organization's policy.
 *
 * @generated from message gitpod.v1.PolicyEnforcedFailedPreconditionDetails
 */
export class PolicyEnforcedFailedPreconditionDetails extends Message<PolicyEnforcedFailedPreconditionDetails> {
  /**
   * message is the message to display to the user
   *
   * @generated from field: string message = 1;
   */
  message = "";

  /**
   * policy_name is the name of the policy that is enforced
   *
   * @generated from field: string policy_name = 2;
   */
  policyName = "";

  constructor(data?: PartialMessage<PolicyEnforcedFailedPreconditionDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PolicyEnforcedFailedPreconditionDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "policy_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PolicyEnforcedFailedPreconditionDetails {
    return new PolicyEnforcedFailedPreconditionDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PolicyEnforcedFailedPreconditionDetails {
    return new PolicyEnforcedFailedPreconditionDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PolicyEnforcedFailedPreconditionDetails {
    return new PolicyEnforcedFailedPreconditionDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PolicyEnforcedFailedPreconditionDetails | PlainMessage<PolicyEnforcedFailedPreconditionDetails> | undefined, b: PolicyEnforcedFailedPreconditionDetails | PlainMessage<PolicyEnforcedFailedPreconditionDetails> | undefined): boolean {
    return proto3.util.equals(PolicyEnforcedFailedPreconditionDetails, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AnnouncementBanner
 */
export class AnnouncementBanner extends Message<AnnouncementBanner> {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * message is the banner message displayed to users. Supports basic Markdown.
   *
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * enabled controls whether the banner is displayed
   *
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  constructor(data?: PartialMessage<AnnouncementBanner>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AnnouncementBanner";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnnouncementBanner {
    return new AnnouncementBanner().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnnouncementBanner {
    return new AnnouncementBanner().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnnouncementBanner {
    return new AnnouncementBanner().fromJsonString(jsonString, options);
  }

  static equals(a: AnnouncementBanner | PlainMessage<AnnouncementBanner> | undefined, b: AnnouncementBanner | PlainMessage<AnnouncementBanner> | undefined): boolean {
    return proto3.util.equals(AnnouncementBanner, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAnnouncementBannerRequest
 */
export class GetAnnouncementBannerRequest extends Message<GetAnnouncementBannerRequest> {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetAnnouncementBannerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAnnouncementBannerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAnnouncementBannerRequest {
    return new GetAnnouncementBannerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAnnouncementBannerRequest {
    return new GetAnnouncementBannerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAnnouncementBannerRequest {
    return new GetAnnouncementBannerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAnnouncementBannerRequest | PlainMessage<GetAnnouncementBannerRequest> | undefined, b: GetAnnouncementBannerRequest | PlainMessage<GetAnnouncementBannerRequest> | undefined): boolean {
    return proto3.util.equals(GetAnnouncementBannerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAnnouncementBannerResponse
 */
export class GetAnnouncementBannerResponse extends Message<GetAnnouncementBannerResponse> {
  /**
   * banner is the announcement banner configuration
   *
   * @generated from field: gitpod.v1.AnnouncementBanner banner = 1;
   */
  banner?: AnnouncementBanner;

  constructor(data?: PartialMessage<GetAnnouncementBannerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAnnouncementBannerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "banner", kind: "message", T: AnnouncementBanner },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAnnouncementBannerResponse {
    return new GetAnnouncementBannerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAnnouncementBannerResponse {
    return new GetAnnouncementBannerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAnnouncementBannerResponse {
    return new GetAnnouncementBannerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAnnouncementBannerResponse | PlainMessage<GetAnnouncementBannerResponse> | undefined, b: GetAnnouncementBannerResponse | PlainMessage<GetAnnouncementBannerResponse> | undefined): boolean {
    return proto3.util.equals(GetAnnouncementBannerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAnnouncementBannerRequest
 */
export class UpdateAnnouncementBannerRequest extends Message<UpdateAnnouncementBannerRequest> {
  /**
   * organization_id is the ID of the organization
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * message is the banner message. Supports basic Markdown. Maximum 1000 characters.
   *
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * enabled controls whether the banner is displayed
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;

  constructor(data?: PartialMessage<UpdateAnnouncementBannerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAnnouncementBannerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAnnouncementBannerRequest {
    return new UpdateAnnouncementBannerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAnnouncementBannerRequest {
    return new UpdateAnnouncementBannerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAnnouncementBannerRequest {
    return new UpdateAnnouncementBannerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAnnouncementBannerRequest | PlainMessage<UpdateAnnouncementBannerRequest> | undefined, b: UpdateAnnouncementBannerRequest | PlainMessage<UpdateAnnouncementBannerRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAnnouncementBannerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAnnouncementBannerResponse
 */
export class UpdateAnnouncementBannerResponse extends Message<UpdateAnnouncementBannerResponse> {
  /**
   * banner is the updated announcement banner configuration
   *
   * @generated from field: gitpod.v1.AnnouncementBanner banner = 1;
   */
  banner?: AnnouncementBanner;

  constructor(data?: PartialMessage<UpdateAnnouncementBannerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAnnouncementBannerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "banner", kind: "message", T: AnnouncementBanner },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAnnouncementBannerResponse {
    return new UpdateAnnouncementBannerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAnnouncementBannerResponse {
    return new UpdateAnnouncementBannerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAnnouncementBannerResponse {
    return new UpdateAnnouncementBannerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAnnouncementBannerResponse | PlainMessage<UpdateAnnouncementBannerResponse> | undefined, b: UpdateAnnouncementBannerResponse | PlainMessage<UpdateAnnouncementBannerResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAnnouncementBannerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetTierRequest
 */
export class SetTierRequest extends Message<SetTierRequest> {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * tier is the new tier to set for the organization
   *
   * @generated from field: gitpod.v1.OrganizationTier tier = 2;
   */
  tier = OrganizationTier.UNSPECIFIED;

  constructor(data?: PartialMessage<SetTierRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetTierRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tier", kind: "enum", T: proto3.getEnumType(OrganizationTier) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetTierRequest {
    return new SetTierRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetTierRequest {
    return new SetTierRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetTierRequest {
    return new SetTierRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetTierRequest | PlainMessage<SetTierRequest> | undefined, b: SetTierRequest | PlainMessage<SetTierRequest> | undefined): boolean {
    return proto3.util.equals(SetTierRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetTierResponse
 */
export class SetTierResponse extends Message<SetTierResponse> {
  constructor(data?: PartialMessage<SetTierResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetTierResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetTierResponse {
    return new SetTierResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetTierResponse {
    return new SetTierResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetTierResponse {
    return new SetTierResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetTierResponse | PlainMessage<SetTierResponse> | undefined, b: SetTierResponse | PlainMessage<SetTierResponse> | undefined): boolean {
    return proto3.util.equals(SetTierResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetStripeCustomerIDRequest
 */
export class SetStripeCustomerIDRequest extends Message<SetStripeCustomerIDRequest> {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * stripe_customer_id is the Stripe customer ID to associate with the organization
   *
   * @generated from field: string stripe_customer_id = 2;
   */
  stripeCustomerId = "";

  constructor(data?: PartialMessage<SetStripeCustomerIDRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetStripeCustomerIDRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stripe_customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetStripeCustomerIDRequest {
    return new SetStripeCustomerIDRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetStripeCustomerIDRequest {
    return new SetStripeCustomerIDRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetStripeCustomerIDRequest {
    return new SetStripeCustomerIDRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetStripeCustomerIDRequest | PlainMessage<SetStripeCustomerIDRequest> | undefined, b: SetStripeCustomerIDRequest | PlainMessage<SetStripeCustomerIDRequest> | undefined): boolean {
    return proto3.util.equals(SetStripeCustomerIDRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetStripeCustomerIDResponse
 */
export class SetStripeCustomerIDResponse extends Message<SetStripeCustomerIDResponse> {
  constructor(data?: PartialMessage<SetStripeCustomerIDResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetStripeCustomerIDResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetStripeCustomerIDResponse {
    return new SetStripeCustomerIDResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetStripeCustomerIDResponse {
    return new SetStripeCustomerIDResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetStripeCustomerIDResponse {
    return new SetStripeCustomerIDResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetStripeCustomerIDResponse | PlainMessage<SetStripeCustomerIDResponse> | undefined, b: SetStripeCustomerIDResponse | PlainMessage<SetStripeCustomerIDResponse> | undefined): boolean {
    return proto3.util.equals(SetStripeCustomerIDResponse, a, b);
  }
}

/**
 * CustomDomain represents a custom domain configuration for an organization
 *
 * @generated from message gitpod.v1.CustomDomain
 */
export class CustomDomain extends Message<CustomDomain> {
  /**
   * id is the unique identifier of the custom domain
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * organization_id is the ID of the organization this custom domain belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 3;
   */
  domainName = "";

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: gitpod.v1.CustomDomainProvider provider = 4;
   */
  provider = CustomDomainProvider.UNSPECIFIED;

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: string aws_account_id = 5 [deprecated = true];
   * @deprecated
   */
  awsAccountId = "";

  /**
   * created_at is when the custom domain was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the custom domain was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: string cloud_account_id = 8;
   */
  cloudAccountId = "";

  constructor(data?: PartialMessage<CustomDomain>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CustomDomain";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "domain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "provider", kind: "enum", T: proto3.getEnumType(CustomDomainProvider) },
    { no: 5, name: "aws_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "updated_at", kind: "message", T: Timestamp },
    { no: 8, name: "cloud_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomDomain {
    return new CustomDomain().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomDomain {
    return new CustomDomain().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomDomain {
    return new CustomDomain().fromJsonString(jsonString, options);
  }

  static equals(a: CustomDomain | PlainMessage<CustomDomain> | undefined, b: CustomDomain | PlainMessage<CustomDomain> | undefined): boolean {
    return proto3.util.equals(CustomDomain, a, b);
  }
}

/**
 * CreateCustomDomainRequest is the request message for creating a custom domain
 *
 * @generated from message gitpod.v1.CreateCustomDomainRequest
 */
export class CreateCustomDomainRequest extends Message<CreateCustomDomainRequest> {
  /**
   * organization_id is the ID of the organization to create the custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 2;
   */
  domainName = "";

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: gitpod.v1.CustomDomainProvider provider = 3;
   */
  provider = CustomDomainProvider.UNSPECIFIED;

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: optional string aws_account_id = 4 [deprecated = true];
   * @deprecated
   */
  awsAccountId?: string;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: optional string cloud_account_id = 5;
   */
  cloudAccountId?: string;

  constructor(data?: PartialMessage<CreateCustomDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCustomDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider", kind: "enum", T: proto3.getEnumType(CustomDomainProvider) },
    { no: 4, name: "aws_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "cloud_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCustomDomainRequest {
    return new CreateCustomDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCustomDomainRequest {
    return new CreateCustomDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCustomDomainRequest {
    return new CreateCustomDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCustomDomainRequest | PlainMessage<CreateCustomDomainRequest> | undefined, b: CreateCustomDomainRequest | PlainMessage<CreateCustomDomainRequest> | undefined): boolean {
    return proto3.util.equals(CreateCustomDomainRequest, a, b);
  }
}

/**
 * CreateCustomDomainResponse is the response message for creating a custom domain
 *
 * @generated from message gitpod.v1.CreateCustomDomainResponse
 */
export class CreateCustomDomainResponse extends Message<CreateCustomDomainResponse> {
  /**
   * custom_domain is the created custom domain
   *
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;

  constructor(data?: PartialMessage<CreateCustomDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCustomDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "custom_domain", kind: "message", T: CustomDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCustomDomainResponse {
    return new CreateCustomDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCustomDomainResponse {
    return new CreateCustomDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCustomDomainResponse {
    return new CreateCustomDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCustomDomainResponse | PlainMessage<CreateCustomDomainResponse> | undefined, b: CreateCustomDomainResponse | PlainMessage<CreateCustomDomainResponse> | undefined): boolean {
    return proto3.util.equals(CreateCustomDomainResponse, a, b);
  }
}

/**
 * GetCustomDomainRequest is the request message for getting a custom domain
 *
 * @generated from message gitpod.v1.GetCustomDomainRequest
 */
export class GetCustomDomainRequest extends Message<GetCustomDomainRequest> {
  /**
   * organization_id is the ID of the organization to retrieve custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetCustomDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCustomDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCustomDomainRequest {
    return new GetCustomDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCustomDomainRequest {
    return new GetCustomDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCustomDomainRequest {
    return new GetCustomDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCustomDomainRequest | PlainMessage<GetCustomDomainRequest> | undefined, b: GetCustomDomainRequest | PlainMessage<GetCustomDomainRequest> | undefined): boolean {
    return proto3.util.equals(GetCustomDomainRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCustomDomainResponse
 */
export class GetCustomDomainResponse extends Message<GetCustomDomainResponse> {
  /**
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;

  constructor(data?: PartialMessage<GetCustomDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCustomDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "custom_domain", kind: "message", T: CustomDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCustomDomainResponse {
    return new GetCustomDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCustomDomainResponse {
    return new GetCustomDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCustomDomainResponse {
    return new GetCustomDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCustomDomainResponse | PlainMessage<GetCustomDomainResponse> | undefined, b: GetCustomDomainResponse | PlainMessage<GetCustomDomainResponse> | undefined): boolean {
    return proto3.util.equals(GetCustomDomainResponse, a, b);
  }
}

/**
 * UpdateCustomDomainRequest is the request message for updating a custom domain
 *
 * @generated from message gitpod.v1.UpdateCustomDomainRequest
 */
export class UpdateCustomDomainRequest extends Message<UpdateCustomDomainRequest> {
  /**
   * organization_id is the ID of the organization to update custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * domain_name is the custom domain name
   *
   * @generated from field: string domain_name = 2;
   */
  domainName = "";

  /**
   * aws_account_id is the AWS account ID (deprecated: use cloud_account_id)
   *
   * @generated from field: optional string aws_account_id = 3 [deprecated = true];
   * @deprecated
   */
  awsAccountId?: string;

  /**
   * cloud_account_id is the unified cloud account identifier (AWS Account ID or GCP Project ID)
   *
   * @generated from field: optional string cloud_account_id = 4;
   */
  cloudAccountId?: string;

  /**
   * provider is the cloud provider for this custom domain
   *
   * @generated from field: optional gitpod.v1.CustomDomainProvider provider = 5;
   */
  provider?: CustomDomainProvider;

  constructor(data?: PartialMessage<UpdateCustomDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateCustomDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "aws_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "cloud_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "provider", kind: "enum", T: proto3.getEnumType(CustomDomainProvider), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCustomDomainRequest {
    return new UpdateCustomDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCustomDomainRequest {
    return new UpdateCustomDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCustomDomainRequest {
    return new UpdateCustomDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCustomDomainRequest | PlainMessage<UpdateCustomDomainRequest> | undefined, b: UpdateCustomDomainRequest | PlainMessage<UpdateCustomDomainRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCustomDomainRequest, a, b);
  }
}

/**
 * UpdateCustomDomainResponse is the response message for updating a custom domain
 *
 * @generated from message gitpod.v1.UpdateCustomDomainResponse
 */
export class UpdateCustomDomainResponse extends Message<UpdateCustomDomainResponse> {
  /**
   * custom_domain is the updated custom domain
   *
   * @generated from field: gitpod.v1.CustomDomain custom_domain = 1;
   */
  customDomain?: CustomDomain;

  constructor(data?: PartialMessage<UpdateCustomDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateCustomDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "custom_domain", kind: "message", T: CustomDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCustomDomainResponse {
    return new UpdateCustomDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCustomDomainResponse {
    return new UpdateCustomDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCustomDomainResponse {
    return new UpdateCustomDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCustomDomainResponse | PlainMessage<UpdateCustomDomainResponse> | undefined, b: UpdateCustomDomainResponse | PlainMessage<UpdateCustomDomainResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCustomDomainResponse, a, b);
  }
}

/**
 * DeleteCustomDomainRequest is the request message for deleting a custom domain
 *
 * @generated from message gitpod.v1.DeleteCustomDomainRequest
 */
export class DeleteCustomDomainRequest extends Message<DeleteCustomDomainRequest> {
  /**
   * organization_id is the ID of the organization to delete custom domain for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<DeleteCustomDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteCustomDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCustomDomainRequest {
    return new DeleteCustomDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCustomDomainRequest {
    return new DeleteCustomDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCustomDomainRequest {
    return new DeleteCustomDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCustomDomainRequest | PlainMessage<DeleteCustomDomainRequest> | undefined, b: DeleteCustomDomainRequest | PlainMessage<DeleteCustomDomainRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCustomDomainRequest, a, b);
  }
}

/**
 * DeleteCustomDomainResponse is the response message for deleting a custom domain
 *
 * @generated from message gitpod.v1.DeleteCustomDomainResponse
 */
export class DeleteCustomDomainResponse extends Message<DeleteCustomDomainResponse> {
  constructor(data?: PartialMessage<DeleteCustomDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteCustomDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCustomDomainResponse {
    return new DeleteCustomDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCustomDomainResponse {
    return new DeleteCustomDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCustomDomainResponse {
    return new DeleteCustomDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCustomDomainResponse | PlainMessage<DeleteCustomDomainResponse> | undefined, b: DeleteCustomDomainResponse | PlainMessage<DeleteCustomDomainResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCustomDomainResponse, a, b);
  }
}

